export const POP= -1;
export const PUSH= 1;
export const REPLACE = 0;

